<tec-modal
    type="confirmation"
    [isVisible]="isVisible"
    [buttonSecondaryLabel]="'DESIGN.MODAL_CANCEL.CANCEL' | translate"
    [buttonPrimaryLabel]="'DESIGN.MODAL_CANCEL.SAVE_EXIT' | translate"
    (closeEvent)="closeModal($event)"
>
    <ng-container body>
        <tec-tag-icon [size]="'default'" [icon]="'icon-alert'" />
        <div class="body__text">
            <h4>{{ 'DESIGN.MODAL_CANCEL.TITLE' | translate }}</h4>
            <span>{{ 'DESIGN.MODAL_CANCEL.DESCRIPTION' | translate }}</span>
        </div>
    </ng-container>
</tec-modal>
